module.exports = __webpack_public_path__ + "img/menu2-4.69adbd35.jpg";